import React, { createContext, useState, useLayoutEffect } from 'react'
import axios from 'axios'
import baseurl from '../services/empresa/baseurl'
import Cookies from 'js-cookie'

export const AuthContext = createContext()

export const AuthContextProvider = ({ children }) => {

    const [Auth, setAuth] = useState(false)
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoadingAuth] = useState(false);
    const [Erro, setErro] = useState("")
    const [Success, setSuccess] = useState("")
    const [AlterarSenhaModal, setAlterarSenhaModal] = useState(false);
    const [ResetarSenhaModal, setResetarSenhaModal] = useState(false)
    const [EmpresaKey, setEmpresaKey] = useState(Cookies.get("Key") || "")

    const dominio = window.location.origin;

    useLayoutEffect(() => {
        const token = Cookies.get("Token")
        const empresaKey = Cookies.get("Key")
        if (token) {
            setAuth(true)
        }
        if (empresaKey) {
            setEmpresaKey(empresaKey)
        }
    }, [])

    const AuthUser = async (event) => {
        event.preventDefault()
        let data = {
            email: email,
            senha: password,
        }
        setLoadingAuth(true)
        return axios({
            url: baseurl + 'Autenticacao/Login',
            method: 'POST',
            data: data,
        }).then((response) => {
            Cookies.set('Token', response.data.accessToken)
            Cookies.set('Username', response.data.userName)
            Cookies.set('Role', response.data.role)
            setLoadingAuth(false)
            setAuth(true)
            return Promise.resolve()
        }).catch((error) => {
            setLoadingAuth(false)
            error.response.data.map((er) => {
                setErro(`${er.campo}: ${er.mensagem}`)
            })
            setTimeout(() => {
                setErro("")
            }, 4000);
            return Promise.reject(error)
        })
    }

    const TrocarSenha = async (novaSenha) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Autenticacao/TrocarSenha",
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: { novaSenha: novaSenha }
        })
            .then((response) => {
                setSuccess(response.data);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoadingAuth(false)
                setAlterarSenhaModal(false)
                return Promise.resolve(response.data)
            })
            .catch((error) => {
                setErro("A senha deve ter no mínimo 8 caracteres.");
                setTimeout(() => {
                    setErro("");
                }, 3000);
                setLoadingAuth(false);
                return Promise.reject(error);
            });
    };

    const ResetarSenha = async (email) => {
        const token = Cookies.get("Token");
        setLoadingAuth(true)
        return axios({
            url: baseurl + "Autenticacao/ResetarSenha?email=" + email + "&UrlOrigem=" + dominio,
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoadingAuth(false)
                setResetarSenhaModal(false)
                setSuccess(response.data);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                setLoadingAuth(false);
                error.response.data.map((er) => {
                    setErro(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setErro("")
                }, 4000);
                console.log(error)
                return Promise.reject(error);
            })
    }

    let data = {
        Auth,
        AuthUser,
        email,
        setEmail,
        password,
        setPassword,
        setAuth,
        loading,setLoadingAuth,
        Erro,
        setErro,
        Success,
        setSuccess,
        TrocarSenha,
        AlterarSenhaModal,
        setAlterarSenhaModal,
        ResetarSenha,
        ResetarSenhaModal,
        setResetarSenhaModal,
        EmpresaKey, setEmpresaKey
        
    }

    return (
        <AuthContext.Provider value={data}>
            {children}
        </AuthContext.Provider>
    )
}